(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    function setCombinedHeaderHeight() {
      // All header group sections
      const headerEls = document.querySelectorAll('.shopify-section-group-header-group');
      let totalHeight = 0;
      headerEls.forEach((el) => {
        totalHeight += el.getBoundingClientRect().height;
      });
      document.documentElement.style.setProperty('--header-height', `${Math.round(totalHeight)}px`);

      // Only the main header (no announcement bar)
      const mainHeaderEls = document.querySelectorAll('gaia-header');
      let mainHeaderHeight = 0;
      mainHeaderEls.forEach((el) => {
        mainHeaderHeight += el.getBoundingClientRect().height;
      });
      document.documentElement.style.setProperty(
        '--header-height-no-announcement',
        `${Math.round(mainHeaderHeight)}px`
      );
    }

    setCombinedHeaderHeight();

    const headerEls = document.querySelectorAll('.shopify-section-group-header-group, .section-header');
    const headerObserver = new ResizeObserver(() => {
      setCombinedHeaderHeight();
    });
    headerEls.forEach((el) => headerObserver.observe(el));

    // Mobile search toggle
    const mobileSearchBtn = document.getElementById('mobile-search-btn');
    const mobileSearchPanel = document.getElementById('mobile-search-panel');
    const mobileLocalisationBtn = document.getElementById('mobile-localisation-btn');
    const mobileLocalisationPanel = document.getElementById('mobile-localisation-panel');
    const mobileMenuEl = document.querySelector('gaia-mobile-menu');
    const mobileMenuDetails = mobileMenuEl?.querySelector('details');

    function closeSearchPanel() {
      mobileSearchPanel.classList.remove('open');
      mobileSearchBtn.setAttribute('aria-expanded', 'false');
      mobileSearchPanel.setAttribute('aria-hidden', 'true');
    }

    function closeLocalisationPanel() {
      mobileLocalisationPanel.classList.remove('open');
      mobileLocalisationBtn.setAttribute('aria-expanded', 'false');
      mobileLocalisationPanel.setAttribute('aria-hidden', 'true');
    }

    if (mobileSearchBtn && mobileSearchPanel) {
      mobileSearchBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = mobileSearchPanel.classList.toggle('open');
        mobileSearchBtn.setAttribute('aria-expanded', isOpen);
        mobileSearchPanel.setAttribute('aria-hidden', !isOpen);
        if (isOpen) {
          // Close the mobile menu and localisation panel if open
          if (mobileMenuEl && mobileMenuDetails?.hasAttribute('open')) {
            mobileMenuEl.close();
          }
          if (mobileLocalisationPanel?.classList.contains('open')) {
            closeLocalisationPanel();
          }
          mobileSearchPanel.querySelector('.search-input')?.focus();
        }
      });

      document.addEventListener('click', (e) => {
        if (!mobileSearchBtn.contains(e.target) && !mobileSearchPanel.contains(e.target)) {
          closeSearchPanel();
        }
      });
    }

    if (mobileLocalisationBtn && mobileLocalisationPanel) {
      mobileLocalisationBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (mobileLocalisationPanel.classList.contains('open')) {
          closeLocalisationPanel();
        } else {
          mobileLocalisationPanel.classList.add('open');
          mobileLocalisationBtn.setAttribute('aria-expanded', 'true');
          mobileLocalisationPanel.setAttribute('aria-hidden', 'false');
          if (mobileMenuEl && mobileMenuDetails?.hasAttribute('open')) {
            mobileMenuEl.close();
          }
          if (mobileSearchPanel?.classList.contains('open')) {
            closeSearchPanel();
          }
        }
      });

      document.addEventListener('click', (e) => {
        if (!mobileLocalisationBtn.contains(e.target) && !mobileLocalisationPanel.contains(e.target)) {
          closeLocalisationPanel();
        }
      });
    }

    // Close search and localisation panels when mobile menu opens
    if (mobileMenuDetails) {
      new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.attributeName === 'open' && mobileMenuDetails.hasAttribute('open')) {
            if (mobileSearchPanel?.classList.contains('open')) {
              closeSearchPanel();
            }
            if (mobileLocalisationPanel?.classList.contains('open')) {
              closeLocalisationPanel();
            }
          }
        });
      }).observe(mobileMenuDetails, { attributes: true, attributeFilter: ['open'] });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
